module.exports = __webpack_public_path__ + "img/te2.19a6de47.png";